export default __webpack_public_path__ + "static/Nutureful-9e18184abdd08e200258d6c66ff29abc.jpg";